import React from 'react';
import classNames from 'classnames';
import SelectionContainer from '../../../containers/SelectionContainer';
import ListItem from './ListItem';
import styles from './ListGroup.module.scss';

export interface Props<T extends string | number = string>
  extends Omit<React.HTMLAttributes<HTMLElement>, 'onChange'> {
  value?: T;
  onChange: (value?: T) => void;
  children: React.ReactNode;
}

const ListGroup = <T extends string | number = string>({
  className,
  style,
  children,
  value,
  onChange,
  ...htmlElementProps
}: React.PropsWithChildren<Props<T>>) => (
  <SelectionContainer
    className={classNames(styles.wrapper, className)}
    style={{ ...style }}
    mode="vertical"
    value={value}
    onChange={(v) => {
      if (!Array.isArray(v)) {
        onChange(v);
      }
    }}
    role="list"
    {...htmlElementProps}
  >
    {children}
  </SelectionContainer>
);

ListGroup.Item = ListItem;

export default ListGroup;
